"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.validationConfig = exports.popoverConfig = exports.payload = exports.initialValuesConfig = exports.initialTouchedConfig = exports.idPrefix = exports.dropdownOptions = exports.componentConfig = exports.calcName = void 0;
var yup = _interopRequireWildcard(require("yup"));
var _sub = _interopRequireDefault(require("date-fns/sub"));
var _utils = require("../../middleware/utils");
var _DefaultValues = require("./DefaultValues");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
var calcName = exports.calcName = 'disability';
var idPrefix = exports.idPrefix = 'di_';
var dropdownOptions = exports.dropdownOptions = {
  haveEmployerArray: ['have', "don't have"],
  planIndArray: ['plan', "don't plan"],
  otherIncomeCovered: ['Yes', 'No'],
  haveEmployePlanTransfer: ['Yes', 'No']
};
var popoverConfig = exports.popoverConfig = {
  yearsToCover: 'Average disability claim is 4 years. Source: MassMutual claims data'
};
var validationPage1 = yup.object().shape({
  birthMonth: yup.number('Month must be a number').required('You must specify a valid month').min(1, 'Invalid Month').max(12, 'Invalid Month'),
  birthDay: yup.number('Day must be a number').required('You must specify a valid day').min(1, 'Invalid Day').max(31, 'Invalid Day'),
  birthYear: yup.number().required('You must specify a valid year'),
  annualEarnedIncome: yup.number().transform(_utils.parseCurrencyString).required('Must be between $0 and $10,000,000').min(0, 'Must be between $0 and $10,000,000').max(10000000, 'Must be between $0 and $10,000,000'),
  estimatedMonthlyExpenses: yup.number().transform(_utils.parseCurrencyString).required('Must be between $0 and $10,000,000').min(0, 'Must be between $0 and $10,000,000').max(10000000, 'Must be between $0 and $10,000,000'),
  haveEmployerPlan: yup.string().required('Must provide an employer plan indicator').oneOf(dropdownOptions.haveEmployerArray),
  planningIndicator: yup.string().required('Must provide a college plan indicator').oneOf(dropdownOptions.planIndArray),
  birthdate: yup.date().typeError('Must be a valid date and between 18 and 65 years of age').required('Must be a valid date and between 18 and 65 years of age').min((0, _sub.default)(new Date(), {
    years: 66
  }), 'Must be a valid date and between 18 and 65 years of age').max((0, _sub.default)(new Date(), {
    years: 18
  }), 'Must be a valid date and between 18 and 65 years of age'),
  cashSavings: yup.number().transform(_utils.parseCurrencyString).required('Must be between $0 and $10,000,000').min(0, 'Must be between $0 and $10,000,000').max(10000000, 'Must be between $0 and $10,000,000')
});
var validationPage2Additions = yup.object().shape({
  otherAnnualIncome: yup.number().transform(_utils.parseCurrencyString).required('Must be between $0 and $10,000,000').min(0, 'Must be between $0 and $10,000,000').max(10000000, 'Must be between $0 and $10,000,000'),
  taxRate: yup.number().transform(parseFloat).required('Must be between 0% and 50% and to a maximum of 2 decimal places').min(0, 'Must be between 0% and 50% and to a maximum of 2 decimal places').max(50, 'Must be between 0% and 50% and to a maximum of 2 decimal places'),
  retirementAge: yup.number().required('Must be between 65-70 years old').min(65, 'Must be between 65-70 years old').max(70, 'Must be between 65-70 years old'),
  yearsToCover: yup.number().required('Must be between 0-30 years old').min(0, 'Must be between 0-30 years old').max(30, 'Must be between 0-30 years old'),
  retirementSavings: yup.number().transform(_utils.parseCurrencyString).required('Must be between $0 and $10,000,000').min(0, 'Must be between $0 and $10,000,000').max(10000000, 'Must be between $0 and $10,000,000'),
  mutualFundsStocksSavings: yup.number().transform(_utils.parseCurrencyString).required('Must be between $0 and $10,000,000').min(0, 'Must be between $0 and $10,000,000').max(10000000, 'Must be between $0 and $10,000,000'),
  percentOfIncomeCovered: yup.number().transform(parseFloat).required('Must be between 0% and 100% and to a maximum of 2 decimal places').min(0, 'Must be between 0% and 100% and to a maximum of 2 decimal places').max(100, 'Must be between 0% and 100% and to a maximum of 2 decimal places'),
  numOfYearsCovered: yup.number().required('Must be between 0-30 years old').min(0, 'Must be between 0-30 years old').max(30, 'Must be between 0-30 years old'),
  monthlyCap: yup.number().transform(_utils.parseCurrencyString).required('Must be between $0 and $20,000').min(0, 'Must be between $0 and $20,000').max(20000, 'Must be between $0 and $20,000'),
  salaryGrowthRate: yup.number().transform(parseFloat).required('Must be between 0% and 10% and to a maximum of 2 decimal places').min(0, 'Must be between 0% and 10% and to a maximum of 2 decimal places').max(10, 'Must be between 0% and 10% and to a maximum of 2 decimal places'),
  inflationRate: yup.number().transform(parseFloat).required('Must be between 0% and 10% and to a maximum of 2 decimal places').min(0, 'Must be between 0% and 10% and to a maximum of 2 decimal places').max(10, 'Must be between 0% and 10% and to a maximum of 2 decimal places')
});
var validationPage2 = validationPage1.concat(validationPage2Additions);
var validationConfig = exports.validationConfig = [validationPage1, validationPage2];
var initialValuesConfig = exports.initialValuesConfig = {
  birthMonth: '',
  birthDay: '',
  birthYear: '',
  annualEarnedIncome: '',
  estimatedMonthlyExpenses: '',
  haveEmployerPlan: _DefaultValues.defaultValues.haveEmployerPlan,
  cashSavings: '',
  planningIndicator: _DefaultValues.defaultValues.planningIndicator,
  otherAnnualIncome: _DefaultValues.defaultValues.otherAnnualIncome,
  taxRate: _DefaultValues.defaultValues.taxRate,
  retirementAge: _DefaultValues.defaultValues.retirementAge,
  yearsToCover: _DefaultValues.defaultValues.yearsToCover,
  retirementSavings: _DefaultValues.defaultValues.retirementSavings,
  mutualFundsStocksSavings: _DefaultValues.defaultValues.mutualFundsStocksSavings,
  percentOfIncomeCovered: _DefaultValues.defaultValues.percentOfIncomeCovered,
  numOfYearsCovered: _DefaultValues.defaultValues.numOfYearsCovered,
  monthlyCap: _DefaultValues.defaultValues.monthlyCap,
  salaryGrowthRate: _DefaultValues.defaultValues.salaryGrowthRate,
  inflationRate: _DefaultValues.defaultValues.inflationRate,
  otherIncomeCovered: _DefaultValues.defaultValues.otherIncomeCovered,
  interestRate: _DefaultValues.defaultValues.interestRate,
  percentOfExpenses: _DefaultValues.defaultValues.percentOfExpenses,
  haveEmployerPlanTransform: ''
};
var initialTouchedConfig = exports.initialTouchedConfig = {
  birthMonth: false,
  birthDay: false,
  birthYear: false
};
var payload = exports.payload = {};
var componentConfig = exports.componentConfig = {
  config: {
    API_URL: 'https://www-qa.massmutual.com/ict/calculate/disability_calculator_v0.1.1',
    Steps: [{
      Title: 'How much disability income insurance do I need?',
      Description: '',
      SecondaryDescription: 'If you were too sick or injured to work, do you have enough income to cover your living expenses? Use the Disability Income Protection Insurance Calculator to find out.',
      BackButton: {
        Label: '',
        Icon: '',
        Variant: ''
      },
      NextButton: {
        Label: 'Next',
        Icon: 'icon-arrow',
        Variant: ''
      }
    }, {
      Title: 'Your Results',
      Description: '',
      BackButton: {
        Label: 'Back',
        Icon: 'icon-arrow-spin-left',
        Variant: 'link'
      },
      NextButton: {
        Label: 'Edit your inputs & our assumptions',
        Icon: '',
        Variant: 'secondary',
        Side: 'L'
      },
      RightHandButton: {
        Label: 'View Disclosure',
        Href: '',
        Target: '',
        Variant: ''
      },
      SideContent: {
        Title: 'Next Step',
        Description: 'It’s worth a discussion, no matter how awkward. Talk to us about disability income insurance today, feel comfortable about tomorrow.',
        CTAList: [{
          Label: 'Get Started',
          Href: '',
          Target: '',
          Variant: 'primary'
        }, {
          Label: 'Learn how disability insurance can help',
          Href: '',
          Target: '',
          Variant: 'link'
        }]
      }
    }]
  }
};